/* Jardin d'Opal - selector de kits en la misma vista (sin ventana emergente), sobre la app Simple Bundles.
   - Casillas en blanco (Diseno 1, 2, 3, Top Coat) + tarjetas fijas (lampara, remover, bolso, set).
   - Debajo de la cuadricula, en la misma pagina, las fotos para elegir la casilla activa.
   - Al elegir, pasa sola a la siguiente casilla. Al completar todo, el panel se recoge.
   - Los disenos agotados no se muestran.
   - No deja anadir al carrito sin completar todas las casillas.
   - El <select> de la app queda oculto pero sigue siendo lo que se envia al carrito. */
(function () {
  if (window.__jdoKitPicker) return;
  window.__jdoKitPicker = true;
  function cfgEl() { return document.querySelector('.jdo-kit-ux'); }
  function tx(k, d) { var c = cfgEl(); return (c && c.getAttribute('data-' + k)) || d; }
  function isOut(full) { var l = window.JDO_SOLDOUT || []; return l.indexOf(full) > -1; }
  var GS = [];
  var PICKED = {};
  var ACTIVE = 0;
  var OPEN = true;
  var WARN = false;
  var timer;

  (function css() {
    if (document.getElementById('jdo-inline-css')) return;
    var st = document.createElement('style');
    st.id = 'jdo-inline-css';
    st.textContent = [
      '.jdo-slot.is-active .jdo-slot__btn{border:2px solid rgb(var(--color-foreground)) !important;box-shadow:0 0 0 3px rgba(var(--color-foreground),.08)}',
      '.jdo-inline{grid-column:1/-1;border:1px solid rgba(var(--color-foreground),.15);border-radius:10px;padding:10px;background:rgba(var(--color-foreground),.02)}',
      '.jdo-inline[hidden]{display:none}',
      '.jdo-inline__title{margin:0 0 8px;font-size:13px;font-weight:600;text-align:center}',
      '.jdo-inline__title.is-warn{color:#b3261e}',
      '.jdo-inline__grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(82px,1fr));gap:8px;max-height:360px;overflow-y:auto;overscroll-behavior:contain;padding:2px}',
      '.jdo-inline__item{display:flex;flex-direction:column;align-items:center;gap:4px;padding:4px;border:1px solid rgba(var(--color-foreground),.15);border-radius:8px;background:rgb(var(--color-background));color:inherit;font:inherit;cursor:pointer;min-width:0}',
      '.jdo-inline__item img{width:100%;aspect-ratio:1/1;object-fit:cover;border-radius:6px;display:block}',
      '.jdo-inline__item span{font-size:11px;line-height:1.2;text-align:center;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}',
      '.jdo-inline__item.is-on{outline:2px solid rgb(var(--color-foreground));outline-offset:-2px}'
    ].join('');
    document.head.appendChild(st);
  })();

  function shortName(s) {
    return (s || '').replace(/ *Nail (Stickers|Wraps) *$/i, '').replace(/^Opal +/i, '').trim();
  }
  function cardFull(b) {
    var nm = b.querySelector('span');
    return nm ? (nm.getAttribute('title') || nm.textContent).trim() : '';
  }
  function optText(s) {
    var o = s.options[s.selectedIndex];
    return o && o.value ? (o.getAttribute('data-full') || o.text).trim() : '';
  }
  function cardFor(g, txt) {
    var found = null;
    if (txt) g.querySelectorAll('.sbk-visual-card').forEach(function (c) { if (!found && cardFull(c) === txt) found = c; });
    return found;
  }
  function setSel(x, full) {
    var s = x.s;
    var card = cardFor(x.g, full);
    if (card) card.click();
    for (var k = 0; k < s.options.length; k++) {
      if ((s.options[k].getAttribute('data-full') || s.options[k].text).trim() === full) { s.selectedIndex = k; break; }
    }
    s.dispatchEvent(new Event('input', { bubbles: true }));
    s.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function labelOf(x, i) {
    return x.lab && x.lab.firstChild ? x.lab.firstChild.textContent.trim() : (tx('design', 'Diseno') + ' ' + (i + 1));
  }
  function blank(x, i) { return !PICKED[labelOf(x, i)]; }
  function firstBlank() {
    for (var i = 0; i < GS.length; i++) { if (blank(GS[i], i)) return i; }
    return -1;
  }

  function groups(r) {
    var out = [];
    r.querySelectorAll('select.sbk-visually-hidden').forEach(function (s) {
      if (!s.__jdoGrid) {
        var g = s.nextElementSibling;
        if (!g || !g.classList.contains('sbk-visual-grid')) return;
        s.__jdoGrid = g;
        s.__jdoLab = s.previousElementSibling && s.previousElementSibling.tagName === 'LABEL' ? s.previousElementSibling : null;
      }
      out.push({ s: s, g: s.__jdoGrid, lab: s.__jdoLab });
    });
    return out;
  }

  function renderPanel(wrap) {
    var p = wrap.querySelector('.jdo-inline');
    if (!p) {
      p = document.createElement('div');
      p.className = 'jdo-inline';
      p.innerHTML = '<p class="jdo-inline__title"></p><div class="jdo-inline__grid" role="list"></div>';
    }
    if (p.parentNode !== wrap || p !== wrap.lastElementChild) wrap.appendChild(p);
    var x = GS[ACTIVE];
    if (!OPEN || !x) { if (!p.hidden) p.hidden = true; return; }
    if (p.hidden) p.hidden = false;
    var lbl = labelOf(x, ACTIVE);
    var title = p.querySelector('.jdo-inline__title');
    var t = WARN ? tx('need', 'Elige tus disenos para continuar') + ' → ' + lbl : tx('pick', 'Elegir') + ': ' + lbl;
    if (title.textContent !== t) title.textContent = t;
    if (title.classList.contains('is-warn') !== WARN) title.classList.toggle('is-warn', WARN);
    var grid = p.querySelector('.jdo-inline__grid');
    var cur = blank(x, ACTIVE) ? '' : optText(x.s);
    var key = ACTIVE + '|' + cur + '|' + (window.JDO_SOLDOUT || []).length;
    if (grid.getAttribute('data-key') === key) return;
    grid.setAttribute('data-key', key);
    grid.innerHTML = '';
    var idx = ACTIVE;
    x.g.querySelectorAll('.sbk-visual-card').forEach(function (c) {
      var full = cardFull(c);
      if (isOut(full)) return;
      var img = c.querySelector('img');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'jdo-inline__item' + (full === cur ? ' is-on' : '');
      b.setAttribute('role', 'listitem');
      b.setAttribute('aria-label', lbl + ': ' + full);
      b.innerHTML = (img ? '<img alt="" loading="lazy" src="' + img.getAttribute('src') + '">' : '') + '<span></span>';
      b.querySelector('span').textContent = shortName(full);
      b.addEventListener('click', function () { pick(idx, full); });
      grid.appendChild(b);
    });
    grid.scrollTop = 0;
  }

  function build() {
    var r = document.getElementById('simple-bundles-io-options');
    if (!r) return;
    r.querySelectorAll('.sbk-visual-card span').forEach(function (sp) {
      if (sp.getAttribute('data-jdo-short')) return;
      var full = sp.textContent.trim();
      sp.setAttribute('data-jdo-short', '1');
      sp.setAttribute('title', full);
      sp.textContent = shortName(full);
    });
    var all = groups(r);
    if (!all.length) return;
    all.forEach(function (x) {
      if (x.s.getAttribute('aria-hidden') !== 'true') { x.s.setAttribute('aria-hidden', 'true'); x.s.setAttribute('tabindex', '-1'); }
      x.s.classList.add('jdo-hide');
      if (x.lab) x.lab.classList.add('jdo-hide');
      x.g.classList.add('jdo-hide');
      for (var k = 0; k < x.s.options.length; k++) {
        var o = x.s.options[k];
        if (o.value && !o.disabled && isOut(o.text.trim())) { o.setAttribute('data-full', o.text.trim()); o.disabled = true; }
      }
    });
    GS = all.filter(function (x) { return x.g.querySelectorAll('.sbk-visual-card').length > 1; });
    var fixed = all.filter(function (x) { return x.g.querySelectorAll('.sbk-visual-card').length <= 1; });

    var wrap = r.querySelector('.jdo-slots');
    if (!wrap) {
      var head = document.createElement('p');
      head.className = 'jdo-slots__title';
      head.textContent = tx('choose', 'Elige tus disenos');
      wrap = document.createElement('div');
      wrap.className = 'jdo-slots';
      r.insertBefore(wrap, r.firstChild);
      r.insertBefore(head, wrap);
    }
    var slots = wrap.querySelectorAll('.jdo-slot');
    var cards = wrap.querySelectorAll('.jdo-fixed__card');

    GS.forEach(function (x, i) {
      var cur0 = x.s.options[x.s.selectedIndex];
      if (cur0 && cur0.disabled) {
        var alt = null;
        x.g.querySelectorAll('.sbk-visual-card').forEach(function (c) { if (!alt && !isOut(cardFull(c))) alt = cardFull(c); });
        if (alt) setSel(x, alt);
      }
      var slot = slots[i];
      if (!slot) {
        slot = document.createElement('div');
        slot.className = 'jdo-slot';
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'jdo-slot__btn';
        b.innerHTML = '<span class="jdo-slot__img"></span><span class="jdo-slot__lbl"></span><span class="jdo-slot__name"></span>';
        b.addEventListener('click', function () { ACTIVE = i; OPEN = true; WARN = false; build(); });
        slot.appendChild(b);
        wrap.insertBefore(slot, wrap.querySelector('.jdo-fixed__card') || wrap.querySelector('.jdo-inline'));
      }
      var lbl = labelOf(x, i);
      var cur = blank(x, i) ? '' : optText(x.s);
      var sel = cardFor(x.g, cur);
      var img = sel && sel.querySelector('img');
      var imgBox = slot.querySelector('.jdo-slot__img');
      var src = img ? img.getAttribute('src') : '';
      if (imgBox.getAttribute('data-src') !== src) {
        imgBox.setAttribute('data-src', src);
        imgBox.innerHTML = src ? '<img alt="" src="' + src + '">' : '<span class="jdo-slot__plus">+</span>';
      }
      if (slot.classList.contains('is-set') !== !!cur) slot.classList.toggle('is-set', !!cur);
      var act = OPEN && i === ACTIVE;
      if (slot.classList.contains('is-active') !== act) slot.classList.toggle('is-active', act);
      var lb = slot.querySelector('.jdo-slot__lbl');
      if (lb.textContent !== lbl) lb.textContent = lbl;
      var nm = slot.querySelector('.jdo-slot__name');
      var nmt = cur ? shortName(cur) : '';
      if (nm.textContent !== nmt) nm.textContent = nmt;
      var bt = slot.querySelector('button');
      var al = lbl + ': ' + (cur || tx('pick', 'Elegir'));
      if (bt.getAttribute('aria-label') !== al) bt.setAttribute('aria-label', al);
      var ex = act ? 'true' : 'false';
      if (bt.getAttribute('aria-expanded') !== ex) bt.setAttribute('aria-expanded', ex);
    });

    fixed.forEach(function (x, i) {
      var c = x.g.querySelector('.sbk-visual-card');
      if (!c) return;
      var card = cards[i];
      if (!card) {
        card = document.createElement('div');
        card.className = 'jdo-fixed__card';
        card.innerHTML = '<span class="jdo-fixed__img"></span><span class="jdo-fixed__name"></span>';
        wrap.insertBefore(card, wrap.querySelector('.jdo-inline'));
      }
      var img = c.querySelector('img');
      var ib = card.querySelector('.jdo-fixed__img');
      var src = img ? img.getAttribute('src') : '';
      if (ib.getAttribute('data-src') !== src) { ib.setAttribute('data-src', src); ib.innerHTML = src ? '<img alt="" src="' + src + '">' : ''; }
      var nm = card.querySelector('.jdo-fixed__name');
      var t = shortName(cardFull(c));
      if (nm.textContent !== t) nm.textContent = t;
    });

    renderPanel(wrap);
  }

  function pick(i, full) {
    var x = GS[i];
    if (!x || isOut(full)) return;
    setSel(x, full);
    PICKED[labelOf(x, i)] = true;
    WARN = false;
    var nb = firstBlank();
    if (i < GS.length - 1 && blank(GS[i + 1], i + 1)) { ACTIVE = i + 1; OPEN = true; }
    else if (nb > -1) { ACTIVE = nb; OPEN = true; }
    else { OPEN = false; }
    setTimeout(build, 60);
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !document.getElementById('simple-bundles-io-options')) return;
    var action = f.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    build();
    var nb = firstBlank();
    if (nb > -1) {
      e.preventDefault();
      e.stopImmediatePropagation();
      ACTIVE = nb; OPEN = true; WARN = true;
      build();
      var p = document.querySelector('.jdo-slots');
      if (p && p.scrollIntoView) p.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, true);

  new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(build, 80); })
    .observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  if (document.readyState !== 'loading') build(); else document.addEventListener('DOMContentLoaded', build);
})();
